import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Globals } from 'src/app/Globals';
import { HttpService } from 'src/app/services/http-service';
import { getSignupUserId } from '../signup-user';

@Component({
  selector: 'app-reg-vehicles',
  templateUrl: './reg-vehicles.component.html',
  styleUrls: ['./reg-vehicles.component.scss']
})
export class RegVehiclesComponent implements OnInit {
  globals = Globals;
  vForm: FormGroup;
  vehiclesData: any[] = [];
  colors: any[] = [];
  carModelsArray: any[] = [];
  selectedVehicleModel: any = {};
  model: any = {};
  pdfTypeCheck: string = null;
  isLoadingResults = false;
  available = true;
  httpSub$: Subscription = null;
  fileToUpload: File = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private service: HttpService
  ) {}

  ngOnInit() {
    this.vForm = this.fb.group({
      vehicleName: ['', Validators.required],
      vehicleCategory: [{ value: '', disabled: true }],
      color: ['', Validators.required],
      model: ['', Validators.required],
      plateNumber: ['', Validators.required],
      commercialInsuranceNumber: ['', Validators.required]
    });
    this.getVehiclesDetails();
  }

  getVehiclesDetails() {
    this.isLoadingResults = true;
    this.service.getRequest(this.globals.urls.DarkCarz.vehicles.getVehcilesDetailToADD).subscribe(
      res => {
        this.isLoadingResults = false;
        if (res.success === 1) {
          this.colors = res.data.vehicleColors || [];
          this.vehiclesData = res.data.vehiclesFound || [];
          if (this.vehiclesData.length) {
            this.setCarModel(this.vehiclesData[0]);
            this.vForm.patchValue({
              vehicleName: this.vehiclesData[0]._id,
              vehicleCategory: this.vehiclesData[0].vehicleCategory
            });
          }
        } else {
          this.service.showError(res['message'], 'ERROR');
        }
      },
      err => {
        this.isLoadingResults = false;
        this.service.showError(err, 'ERROR');
      }
    );
  }

  selectedVehicle(vid: string) {
    for (let i = 0; i < this.vehiclesData.length; i++) {
      if (this.vehiclesData[i]._id === vid) {
        this.setCarModel(this.vehiclesData[i]);
        this.vForm.patchValue({
          vehicleCategory: this.vehiclesData[i].vehicleCategory,
          model: ''
        });
        break;
      }
    }
  }

  setCarModel(vehicle: any) {
    const years: any[] = [];
    for (let i = vehicle.minModelYear; i <= vehicle.maxModelYear; i++) {
      years.push(i);
    }
    this.carModelsArray = years;
    this.selectedVehicleModel = {
      vehicleID: vehicle._id,
      vehicleName: vehicle.name,
      vehicleCategory: vehicle.vehicleCategory,
      vehicleModels: this.carModelsArray
    };
  }

  toggleAvailability() {
    this.available = !this.available;
  }

  uploadInsurance(files: FileList) {
    if (!files || !files[0]) {
      return;
    }
    if (files[0].type === 'image/gif') {
      this.service.showError('Gif images are not allowed', 'Add Vehicle');
      return;
    }
    this.fileToUpload = files.item(0);
    this.isLoadingResults = true;
    this.httpSub$ = this.service.uploadImage(this.globals.urls.signUp.noauth.uploadPDF, this.fileToUpload).subscribe(
      res => {
        this.isLoadingResults = false;
        const result = res.data.url.substring(res.data.url.lastIndexOf('.')).toLowerCase();
        if (result === '.pdf') {
          this.pdfTypeCheck = result;
          this.model.insuranceImage = null;
        } else {
          this.model.insuranceImage = res.data.url;
          this.pdfTypeCheck = null;
        }
        this.model.insurance = res.data.url;
      },
      err => {
        this.isLoadingResults = false;
        this.service.showError(err, 'ERROR');
      }
    );
  }

  clearInsurance() {
    this.model.insurance = null;
    this.model.insuranceImage = null;
    this.pdfTypeCheck = null;
  }

  addVehicle() {
    if (this.vForm.invalid) {
      return;
    }
    const merchantId = getSignupUserId();
    const params: any = {
      merchantId,
      _id: merchantId,
      vehicleTypeId: this.selectedVehicleModel.vehicleID,
      vehicleColorId: this.vForm.getRawValue().color,
      vehicleModel: this.vForm.getRawValue().model,
      vehiclePlateNumber: this.vForm.getRawValue().plateNumber,
      vehicleCommercialInsuranceNumber: this.vForm.getRawValue().commercialInsuranceNumber,
      vehicleCommercialInsuranceDocument: this.model.insurance,
      status: this.available ? 1 : 2
    };
    this.isLoadingResults = true;
    this.service.postRequest(this.globals.urls.signUp.noauth.newVehicle, params).subscribe(
      res => {
        this.isLoadingResults = false;
        if (res.success === 1) {
          this.service.showSuccess(res.message, 'Successfully Added');
          this.router.navigate(['/registration/drivers/profile-details']);
        } else {
          this.service.showError(res.message, 'Error');
        }
      },
      err => {
        this.isLoadingResults = false;
        this.service.showError(err, 'ERROR');
      }
    );
  }
}
